import React from "react";
import { Localize } from "components/service";
import UserCompanyField from "components/users/fields/user-company-field";
import UserInfoField from "components/users/fields/user-info-field";
import UserRoleField from "components/users/fields/user-role-field";
import {
    STAFF_WORKER_STATUS,
    formatStaffWorkerDuration,
    getStaffWorkerRoleColor,
} from "./staff-workers-api-helper";


const EMPTY_VALUE = "—";

const TextCell = ({ children, extraClass = "" }) => (
    <span
        className={ `staff-workers-table__cell ${ extraClass }` }
        title={ typeof children === "string" && children ? children : undefined }>
        { children || EMPTY_VALUE }
    </span>
);

const WORKER_STATUS_TRANSLATIONS = {
    [ STAFF_WORKER_STATUS.checkedIn ]: "STAFF_MANAGEMENT.WorkersStatus_CheckedIn",
    [ STAFF_WORKER_STATUS.notCheckedIn ]: "STAFF_MANAGEMENT.WorkersStatus_NotCheckedIn",
    [ STAFF_WORKER_STATUS.onSiteNow ]: "STAFF_MANAGEMENT.WorkersStatus_OnSiteNow",
};

const WorkerStatusCell = ({ status }) => {
    const translation = WORKER_STATUS_TRANSLATIONS[ status ];

    return (
        <TextCell extraClass={ `staff-workers-table__status staff-workers-table__status--${ status || "unavailable" }` }>
            { translation ? <Localize>{ translation }</Localize> : EMPTY_VALUE }
        </TextCell>
    );
};

const StaffWorkersTableHelper = {
    columns: [
        {
            title: <Localize>TABLES.Column_Title_Name</Localize>,
            dataIndex: "name",
            width: 188,
        },
        {
            title: <Localize>TABLES.Column_Title_Phone</Localize>,
            dataIndex: "phone",
            width: 176,
        },
        {
            title: <Localize>TABLES.Column_Title_Email</Localize>,
            dataIndex: "email",
            width: 258,
        },
        {
            title: <Localize>STAFF_MANAGEMENT.Column_Subcontractor</Localize>,
            dataIndex: "subcontractor",
            width: 177,
        },
        {
            title: <Localize>TABLES.Column_Title_UserGroup</Localize>,
            dataIndex: "role",
            width: 238,
        },
        {
            title: <Localize>STAFF_MANAGEMENT.Column_Status</Localize>,
            dataIndex: "status",
            width: 140,
        },
        {
            title: <Localize>STAFF_MANAGEMENT.Column_TotalHours</Localize>,
            dataIndex: "totalHours",
            width: 141,
        },
    ],

    data: (users = [], currentObj = {}) => (users || []).filter(Boolean).map((user) => {
        const role = user.role || {};
        const sessionSummary = currentObj.sessionSummaries?.[ String(user.id) ];
        const totalHours = formatStaffWorkerDuration(sessionSummary?.totalWorkedSeconds);

        return {
            key: user.id,
            name: (
                <TextCell>
                    <UserInfoField
                        className="staff-workers-table__name"
                        emptyValue={ EMPTY_VALUE }
                        linked={ false }
                        user={ user } />
                </TextCell>
            ),
            phone: <TextCell>{ user.phone }</TextCell>,
            email: <TextCell extraClass="staff-workers-table__email">{ user.email }</TextCell>,
            subcontractor: (
                <TextCell>
                    <UserCompanyField
                        className="staff-workers-table__subcontractor"
                        emptyValue={ EMPTY_VALUE }
                        linked={ false }
                        subcontractor={ user.subcontractor } />
                </TextCell>
            ),
            role: (
                <TextCell>
                    <UserRoleField
                        className="staff-workers-table__role"
                        emptyValue={ EMPTY_VALUE }
                        linked={ false }
                        role={ {
                            ...role,
                            colorHex: getStaffWorkerRoleColor(role.colorHex),
                        } } />
                </TextCell>
            ),
            status: <WorkerStatusCell status={ sessionSummary?.status } />,
            totalHours: (
                <TextCell extraClass={ `staff-workers-table__total-hours${ totalHours ? "" : " staff-workers-table__unavailable" }` }>
                    { totalHours || EMPTY_VALUE }
                </TextCell>
            ),
        };
    }),
};

export default StaffWorkersTableHelper;
